import React, { useEffect, useRef } from 'react';
import { Card, CardContent } from './ui/card';
import './ContactForm.css';

export const ContactForm = () => {
  const formContainerRef = useRef(null);

  useEffect(() => {
    const gfSource = document.getElementById('aquify-gf-contact-form');
    if (gfSource && formContainerRef.current) {
      // Move form into the React container
      formContainerRef.current.appendChild(gfSource);
      gfSource.style.display = 'block';
    }

    return () => {
      // Cleanup: move it back to body on unmount
      if (gfSource) {
        gfSource.style.display = 'none';
        document.body.appendChild(gfSource);
      }
    };
  }, []);

  return (
    <Card className="border-2 border-gray-200 shadow-xl h-full w-full max-w-3xl mx-auto">
      <CardContent className="p-4 md:p-8 h-full">
        <div className="aquify-gf-wrapper">
          <div ref={formContainerRef}>
            {/* Fallback for local development or when GF is missing */}
            <div className="hidden last:block text-center text-gray-500 py-12">
              <p>Loading form...</p>
              <p className="text-sm mt-2">If you are viewing this locally without WordPress, the live form will not appear.</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ContactForm;
